<template>
  <div>
    <assessment-view :userId="id"></assessment-view>
  </div>
</template>

<script>
import { AssessmentsAPI } from "@/lib/api"
import titleMixin from "@/mixins/titleMixin"
import AssessmentView from "@/containers/assessments/AssessmentView"
import User from "@/lib/user"
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  components: {
    AssessmentView
  },
  mixins: [titleMixin],
  created() {
    this.title = "Assessments"
    this.id = User.getUserId()
    this.$store.dispatch("assessments/assessmentsByUserId", {
      userId: User.getUserId()
    })
  }
}
</script>
